import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes } from "@ryde/layout";

import { StationsPageContent } from "./stations.page.content";

export const StationsPage: FC = () => {
  return (
    <PageContextWrapper entity="station">
      <StationsPageContent />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
